import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../cn';
import { BADGE_VARIANTS } from '../../constants';

const SIZE_CLASSES = {
  xxs: 'px-2 py-0.5 text-[10px]',
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-sm',
  lg: 'px-3 py-1 text-sm'
};

const VARIANT_CLASSES = {
  default: 'bg-gray-100 text-gray-800',
  primary: 'bg-primary-100 text-primary-800',
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  neutral: 'bg-white text-gray-600 border border-gray-200'
};

const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  ...props
}) => (
  <span
    className={cn(
      'inline-flex items-center font-medium rounded-full',
      SIZE_CLASSES[size],
      VARIANT_CLASSES[variant],
      className
    )}
    {...props}
  >
    {children}
  </span>
);

Badge.displayName = 'Badge';

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(BADGE_VARIANTS),
  size: PropTypes.oneOf(['xxs', 'sm', 'md', 'lg']),
  className: PropTypes.string
};

export default Badge;
